module.exports = __webpack_public_path__ + "static/media/BT.d6cd9546.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BT.svg
// module id = 212
// module chunks = 0